import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { useEffect } from "react";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";
import { DiscoverPlayersDataTable } from "features/discover/DiscoverPlayersDataTable";

export function DiscoverPlayersDataPage() {
    useEffect(() => { setScrollBehavior() }, []);

	return (
		<div className="discover-container discover-container--wide">
			<div className="pageHeading">
				<DiscoverBreadcrumbs items={[
					{
						label: 'Players data',
					},
				]}/>
			</div>
			<div className="discover-card discover-card--for-table">
				<DiscoverPlayersDataTable />
			</div>
		</div>
	)
}
